import NetworkApi from './networkApi';
import paths from './path';

const fetchRoles = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const data = await NetworkApi.get(`${paths.getRoles}`, headers);

  return data;
};
export default fetchRoles;
